import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';

import { parseOrderDetails } from '../lib/order/parseOrderDetails';
import { orderFragment } from '../lib/order/fragments/order-fragment';

export const query = gql`
  query GetOrder($orderId: Int!) {
    order(id: $orderId) {
      ...OrderFragment
    }
  }

  ${orderFragment}
`;

export function useOrderQuery({ orderId }) {
  const { data, loading, error, refetch } = useQuery(query, {
    skip: !orderId,
    fetchPolicy: 'network-only',
    variables: { orderId },
  });
  const order = data?.order || {};

  const {
    bets,
    discounts,
    games,
    hasFreeTrial,
    hasPromoCodes,
    guaranteeDays,
    isAdHocMembershipOrder,
    memberships,
  } = parseOrderDetails(order);

  return {
    bets,
    discounts,
    error,
    games,
    guaranteeDays,
    hasFreeTrial,
    hasPromoCodes,
    isAdHocMembershipOrder,
    loading,
    memberships,
    order,
    refreshOrder: () => refetch(data.variables),
  };
}
